import { render, staticRenderFns } from "./CTailwindPill.vue?vue&type=template&id=a103cbdc&scoped=true"
import script from "./CTailwindPill.vue?vue&type=script&lang=js"
export * from "./CTailwindPill.vue?vue&type=script&lang=js"
import style0 from "./CTailwindPill.vue?vue&type=style&index=0&id=a103cbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a103cbdc",
  null
  
)

export default component.exports